import Style from './issueStateIndicator.module.css';
import { useLayoutEffect, useState, FC } from 'react';
import { IssuesStateEnum, StudyRoleClaimValue } from '../../../services/api/api-client';
import { useHasStudyClaims } from '../../../helpers/auth/auth-helper';
import { ReactComponent as Opened } from '../../../assets/img/issues/opened_24.svg';
import { ReactComponent as Closed } from '../../../assets/img/issues/closed_24.svg';
import { ReactComponent as Processed } from '../../../assets/img/issues/pre_close_24.svg';
import { Loading } from 'uikit/suspense/Loading';

const onHoverStateIcon = {
  [IssuesStateEnum.Opened]: <Processed />,
  [IssuesStateEnum.Processed]: <Opened />,
};

export const stateIcons = {
  [IssuesStateEnum.Opened]: <Opened />,
  [IssuesStateEnum.Processed]: <Processed />,
  [IssuesStateEnum.Closed]: <Closed />,
};

export type IssueStateType = {
  state: IssuesStateEnum;
  disabled?: boolean;
  isLoading?: boolean;
  onClick: () => void;
};

export const IssueStateIndicator: FC<IssueStateType> = ({ state, disabled, isLoading, onClick }) => {
  const { hasStudyClaim } = useHasStudyClaims();
  const [issueStateIcon, setIssueStateIcon] = useState<JSX.Element | undefined>(undefined);

  useLayoutEffect(() => {
    setIssueStateIcon(stateIcons[state]);
  }, [state]);

  const enabled =
    hasStudyClaim(StudyRoleClaimValue.IssueProcess) &&
    (state === IssuesStateEnum.Opened || state === IssuesStateEnum.Processed);

  const onMouseEnterHandler = () => {
    setIssueStateIcon(onHoverStateIcon[state]);
  };

  const onMouseLeaveHandler = () => {
    setIssueStateIcon(stateIcons[state]);
  };

  return (
    <div className={Style.container} data-test-id={'issue-card-status-icon'}>
      <Loading
        testId={'issue-state-indicator'}
        loading={!!isLoading}
        renderChildren={false}
        loaderClassName={Style.loader}
      >
        <button
          className={Style.changeStateButton}
          disabled={!enabled || disabled}
          onClick={async (e) => {
            e.stopPropagation();
            onClick();
          }}
          onMouseEnter={onMouseEnterHandler}
          onMouseLeave={onMouseLeaveHandler}
        >
          {issueStateIcon}
        </button>
      </Loading>
    </div>
  );
};
